/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
	mediaType: string;
	reconStatus?: string;
	batchName: string;
}
const SReconcileStickyHeader: React.FC<Props> = ({
	mediaType,
	reconStatus,
	batchName,
}) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	return (
		<div className="sticky top-0 z-40 bg-white border-b border-slate-200 px-8 py-3 flex items-center justify-between shadow-sm">
			<div className="flex items-center gap-4">
				<button
					onClick={() => navigate(-1)}
					className="w-10 h-10 rounded-xl border border-slate-200 flex items-center justify-center text-slate-400 hover:text-orange-500 hover:bg-orange-50 transition-all"
				>
					<span className="material-symbols-outlined text-xl">
						arrow_back
					</span>
				</button>
				<div>
					<div className="flex items-center gap-3">
						<h1 className="text-xl font-black text-slate-800 tracking-tight uppercase">
							{t("mediaReconcile.physicalReconciliation.title")}:{" "}
							{mediaType}
						</h1>
						<span className={`px-2.5 py-0.5 text-[10px] font-black uppercase rounded-full border
							${
								reconStatus === "PENDING"
									? "text-blue-700 bg-blue-50 border-blue-100"
									: "text-green-700 bg-green-50 border-green-100"
							}`}>
							{reconStatus}
						</span>
					</div>
					<p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">
						{batchName} •{" "}
						{t("mediaReconcile.physicalReconciliation.monthlyAudit")}
					</p>
				</div>
			</div>
			<div className="flex items-center gap-3">
				<button className="px-4 py-2 bg-white border border-slate-200 text-slate-600 rounded-lg font-black text-[10px] uppercase tracking-widest hover:bg-slate-50 shadow-sm transition-all">
					{t("mediaReconcile.physicalReconciliation.monthlyAudit")}
				</button>
			</div>
		</div>
	);
};

export default SReconcileStickyHeader;
